import {
  findAbnormalAlarm,  // 告警接口
} from "@/api/safetyMonitoringApi"

import {
  getTotime,  // 获取当前时间
} from "@/utils";

export default {
  name: 'equipMixins',

  data () {
    return {
      warnPreTime: '',

      interVal: null
    }
  },

  created () {
    this.getWarningNum()
    // 每段时间，获取异常消息数
    if (!this.interVal) {
      this.interVal = setInterval(() => {
        this.getWarningNum()
      }, 60 * 1000)
    }
  },

  beforeDestroy () {
    if (!this.interVal) {
      this.interVal = null
      clearInterval(this.interVal)
    }
  },

  methods: {
    openAudio () {
      let audio = new Audio();
      audio.src = '/static/mp3/warning.mp3';
      audio.play();
    },

    // 循环获取异常消息
    getWarningNum () {
      if (!this.$route.fullPath.includes('/equipSafeMan/')) {
        return
      }
      // << 正式
      let sendObj = {
        time: this.warnPreTime
      }
      // 调用获取节点
      findAbnormalAlarm(sendObj).then(res => {
        if (res.data.code == 200) {
          this.warnPreTime = getTotime('second')
          let list = res.data.list || []
          if (list.length == 0) {
            return
          }

          // 存在告警
          let nameStr = []
          for (let item of list) {
            nameStr.push(item.name)
          }
          let str = ""
          if (nameStr.length > 2) {
            str = `告警设备：【${nameStr[0]}】、【${nameStr[1]}】等，请点击查看。`
          } else {
            str = `告警设备：【${nameStr.join('、')}】，请点击查看。`
          }
          setTimeout(() => {
            let toTime = getTotime()
            this.$notify({
              title: `异常告警（${toTime}）`,
              message: str,
              position: 'bottom-right',
              duration: 59000,
              type: 'warning',
              onClick: () => {
                this.$router.push({ path: `/equipSafeMan/abnormalAlarmMan` })
              },
            });
            this.openAudio()
          }, 200)
        } else {
          this.$message.warning(res.data.msg)
        }
      })
    },
  }
}